import { post, get } from "./http";
// import common from './constants';
// let basic = common.interfacePath.serverTestUrl
const accountApi = {
  // login: (params) => {
  //   return post("/account/login", params);
  // },// 请求登录
  login: (params) => {
    // return post("/app/account/login", params);
    return post("/account/login", params);
  },// 请求登录
  loginApp: (params) => {
    // return post("/app/account/login", params);
    return post("/account/login/app", params);
  },// app请求登录
  getPassword: (params) => {
    // return post("/app/account/login", params);
    return get("/account/getVerificationCodeForResetPassword", params);
  },// 请求图形验证码
  updateMobile: (params) => {
    return post("/account/updateMobile", params);
  },
  //修改密码
  // resetPassword: (params) => {
  //   return get("/account/resetPassword", params);
  // }, //重置密码
  resetPassword: (params) => {
    return get("/n/forgot/password/set", params);
  }, //重置密码
  newResetPassword: (params) => {
    return post("/account/resetPassword/app", params);
  }, //重置密码
  // 更新地址接口 
  newAppVersion: (params) => {
    return post(`/sys/param/newAppVersion`, params);
  },
  sendSmsCode: (params) => {
    return post("/account/sendSmsCode", params);
  },//发送短信验证码
  verifyMessageCode: (params) => {
    return post("/account/verifyMessageCode", params);
  },//校验短信验证码
  sendLoginSms: (params) => {
    return post("/account/sendLoginSms", params);
  },//发送登录短信验证码
  smsLogin: (params) => {
    return post("/account/smsLogin", params);
  },// 短信登录
  // 维护个人信息
  getPersonalDetails: (params) => {
    return post("/account/getAccountById", params);
  },
  ediitPersonalDetails: (params) => {
    return post("/account/updateAccount", params);
  },
  // 找回密码 
  getResetPassword: (params) => {
    return post(`/account/resetPassword`, params);
  },
  //    修改登录密码
  updatePassword: params => { return post(`account/updatePassword`, params); },
  //    修改登录密码
  updatePhone: params => { return post(`/account/updateMobile`, params); },
  //验证密码是否正确
  accountCheck: params => { return post(`/account/check`, params); },
  // /account/sendMessageCode
  sendMessageCode: params => { return post(`/account/sendMessageCode`, params) },//发送验证码
  // 校验登录账号
  resetPasswordStep1: params => { return post(`/account/checkAccount`, params); },
  // 短信验证码
  smsCodeData: params => { return post(`/account/sendSmsCode`, params); },
  // 短信验证码
  smsCodeDataNumCal: params => { return post(`/account/sendMessageCodeByNumCal`, params); },
  //省查询
  listCRMProvince: params => { return post(`/account/listCRMProvince`, params); },
  //市查询
  listCRMCity: params => { return post(`/account/listCRMCity`, params); },

  getVerificationCode: params => { return post(`/account/sendMessageCode`, params); }, //验证码
  registeredData: params => { return post(`/account/register`, params); },  //注册
  getAgreement: params => { return post(`/merchant/listAgreement`, params); },  // 协议
  getIsAuthed: params => { return post(`/account/getAccountById`, params); },
  register: params => { return post(`/company/register`, params); },
  getListAllOrganization: params => { return post(`/system/getListAllOrganization`, params); },
  getProductLIst: params => { return post(`product/batchListCodeSet`, params); },
  isCrmExist: params => { return post(`/Company/isCrmExist`, params); },
  recognizeBusinessLicense: params => { return post(`/company/recognizeBusinessLicense`, params); },
};
export default accountApi;
